import { ChevronDown, ChevronRight } from 'lucide-react';
import { useState } from 'react';

interface EditorGroupProps {
  name: string;
  children?: React.ReactNode;
}

export default function EditorGroup({ name, children }: EditorGroupProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    // Sibling margins collapse, so my-10 yields 40px between groups.
    <div className="my-10 first:mt-3">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1.5 text-gray-400"
      >
        {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        <span className="text-sm uppercase">{name}</span>
      </button>
      {isOpen && <div className="mt-2 space-y-3">{children}</div>}
    </div>
  );
}
